// ABOUTME: Renders a "ticket reassigned to X" activity pill for a chat update.
// ABOUTME: Orange gradient pill with the assignee displayed in a chip on the right.

import { Box, useTheme } from "@mui/material";
import { useTranslation } from "react-i18next";
import Text from "../../../../../../../components/theme/text/Text";
import { tokens } from "../../../../../../../theme";
import { support_ticket_activity_action } from "../../../../../../../utils/staticEnums";

const MessageTypeReassignment = ({ update }) => {
    const { t } = useTranslation();
    const theme = useTheme();
    const colors = tokens(theme.palette.mode);

    // On UNASSIGNED the assignee chip holds the person the ticket was taken
    // away from, so the label must read "unassigned from", not "assigned to".
    const isUnassigned = update.type === support_ticket_activity_action.UNASSIGNED;

    return (
        <Box
            sx={{
                height: 40,
                borderRadius: 5,
                background: `linear-gradient(to right, ${theme.palette.mode === "dark" ? colors.grey[300] : colors.grey[0]} -15%, ${colors.orange[200]} 150%), ${theme.palette.mode === "dark" ? "black" : "white"}`,
                border: `1px solid ${theme.palette.mode === "dark" ? colors.grey[400] : colors.grey[100]}`,
                pr: 0.5,
                pl: 2,
                display: "flex",
                alignItems: 'center',
                justifyContent: "space-between",
                gap: 1.5,
            }}
        >
            <Text noBreak fontSize={13}>{t(isUnassigned ? "ticket_unassigned_from" : "ticket_reassigned_to")}</Text>
            <Box
                sx={{
                    flexShrink: 0,
                    height: 32,
                    px: 2,
                    borderRadius: 4,
                    background: colors.orange[100],
                    lineHeight: "32px",
                }}
            >
                <Text fontSize={13} bold variant="orange">{update.assignee?.name}</Text>
            </Box>
        </Box>
    );
};

export default MessageTypeReassignment;
